import {
  ExplorerUrlOptions,
  getExplorerUrl,
} from 'src/common/utils/web3/getExplorerUrl'
import useActiveOrDefaultChain from './useActiveOrDefaultChain'

const useOpenExplorerLink = () => {
  const chain = useActiveOrDefaultChain()

  const openExplorer = (options: Omit<ExplorerUrlOptions, 'chainId'>) => {
    const explorerUrl = getExplorerUrl({
      chainId: chain.id,
      ...options,
    })

    window.open(explorerUrl, '_blank')
  }

  return openExplorer
}

export default useOpenExplorerLink
